module.exports = __webpack_public_path__ + "img/icon_search-w.68c9e030.svg";